import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';

export default class EndDialog extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {number} x 
   * @param {number} y 
   */
  constructor(scene, x, y, time, bestTime) {
    super(scene, x, y);

    this.overBox = this.scene.add.container();

    let overTxt = ABCyaPhaser.Text.addText(0, 0, 60, 0xffffff, FontKeys._odin_roundedregular, ABCyaPhaser.Localization.instance.getLocalizedString("end_screen.great_job"), this, false);
    let overBg = this.createBgRect(0xF8DCBC, 0xF3B98D, overTxt.width + 200, 150);
    overBg.x = -((overTxt.width + 200) / 2);
    overTxt.x = -overTxt.width / 2;
    overTxt.y = 75 - (overTxt.height / 2);
    this.overBox.add([overBg, overTxt]);
    this.overBox.endY = 0;
    this.overBox.y = -(this.scene.scale.height);
    this.add(this.overBox);

    this.timeBox = this.scene.add.container();
    let timeBg = this.createBgRect(0xF8DCBC, 0xffffff, overTxt.width + 200, 150);
    timeBg.x = -((overTxt.width + 200) / 2);
    let timeTxt = ABCyaPhaser.Text.addText(0, 0, 40, 0x9B5940, FontKeys._odin_roundedregular, ABCyaPhaser.Localization.instance.getLocalizedString("end_screen.time_label") + " " + Math.round(time) + "\n" + ABCyaPhaser.Localization.instance.getLocalizedString("end_screen.best_time_label") + " " + Math.round(bestTime), this, true).setOrigin(0);
    timeTxt.x = -timeTxt.width / 2;
    timeTxt.y = 75 - (timeTxt.height / 2);
    this.timeBox.add([timeBg, timeTxt]);
    this.timeBox.endY = 250;
    this.timeBox.y = this.timeBox.endY - this.scene.scale.height;
    this.add(this.timeBox);

    this.againBtn = this.scene.add.container(0, 0);
    this.add(this.againBtn);
    const againBg = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._game_items_btn_playagain, this.againBtn);
    ABCyaPhaser.Container.setContainerInteractive(this.againBtn);
    const againTxt = ABCyaPhaser.Text.addText(32, 0, 50, 0x60ba47, FontKeys._odin_roundedregular, ABCyaPhaser.Localization.instance.getLocalizedString("play_again_button"), this.againBtn);
    ABCyaPhaser.Text.resizeFontToFitWidth(againTxt, 300, 60);
    ABCyaPhaser.Buttons.convertToButton(this.againBtn, { onClick: () => this.emit(PAUSE_POPUP_EVENTS.quit) });
    this.againBtn.disableInteractive();

    this.againBtn.endY = this.timeBox.endY + (gameData.isMobile ? 350 : 300) - 18;
    this.againBtn.y = this.againBtn.endY - this.scene.scale.height;
    this.add(this.againBtn);
  }

  showDialog() {
    ABCyaPhaser.Tweens.addTween(this.overBox, 700, { y: this.overBox.endY }, Phaser.Math.Easing.Quadratic.Out);
    ABCyaPhaser.Tweens.addTween(this.timeBox, 700, { y: this.timeBox.endY, delay: 500 }, Phaser.Math.Easing.Quadratic.Out);
    ABCyaPhaser.Tweens.addTween(this.againBtn, 700, { y: this.againBtn.endY, delay: 1000 }, Phaser.Math.Easing.Quadratic.Out, this.dialogReady.bind(this));
  }

  dialogReady() {
    this.againBtn.setInteractive().once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.dismissDialog, this);
  }

  dismissDialog() {
    this.againBtn.disableInteractive();
    this.emit("END_DIALOG");
  }

  createBgRect(outline, fill, boxWidth, boxHeight) {
    let bg = this.scene.add.graphics({ lineStyle: { color: outline, width: 6 }, fillStyle: { color: fill } });
    bg.fillRoundedRect(0, 0, boxWidth, boxHeight, 12);
    bg.strokeRoundedRect(0, 0, boxWidth, boxHeight, 12);
    return bg;
  };
}